import { render, staticRenderFns } from "./TextAreaEmoJ.vue?vue&type=template&id=9a6040de&scoped=true"
import script from "./TextAreaEmoJ.vue?vue&type=script&lang=ts"
export * from "./TextAreaEmoJ.vue?vue&type=script&lang=ts"
import style0 from "./TextAreaEmoJ.vue?vue&type=style&index=0&id=9a6040de&prod&lang=scss"
import style1 from "./TextAreaEmoJ.vue?vue&type=style&index=1&id=9a6040de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6040de",
  null
  
)

export default component.exports